import { useLocation, useNavigate } from "react-router-dom"
import VerticalRule from "../components/VerticalRule"
import FlexColumn from "../layout/FlexColumn"
import PageContainer from "../layout/PageContainer"
import PortfolioCopy from "../layout/PortfolioCopy"
import PortfolioScroller from "../layout/PortfolioScroller"
import { useEffect, useState } from "react"
import { getSelected } from "../utils/nbutils"
import { svgImport, jpgImport } from "../images/SVGImageUtil"
import { section } from "framer-motion/client"

const sectionID = 'press';

const markdown = `
nico & byrne press ***mentions***,
for those of you who are curious
`

const scrollerObject = {
    data : [
        { name : "Deadline", 
            slug : "deadline-69prod",
            headline : "SUMMER OF 69", h2 : "Production Announcement",
            link : "https://deadline.com/2024/07/jillian-bell-chloe-fineman-team-summer-of-69-american-high-hulu-1235999345/",
            linkText : "Read on Deadline",
            hero : { altText : "69 Deadline Article", image : "jpg/rightcol/summerof69-deadline-announce.jpg", section : sectionID },
            hideThumbText : true,
            thumbBackground : "svg/Deadline.svg",
            copy : { 
                text : `EXCLUSIVE: Actress Jillian Bell (Brittany Runs a Marathon) is set 
                to make her feature directorial debut with Summer of 69, an American High 
                comedy for Hulu, starring Saturday Night Live‘s Chloe Fineman.

Written by ***Liz Nico***, ***Jules Byrne***, Jillian Bell, the film’s cast also 
includes Sam Morelos (That ’90s Show), Charlie Day (It’s Always Sunny in 
Philadelphia), Natalie Morales (The Morning Show), Alex Moffat (Saturday 
Night Live), Paula Pell (Girls5eva), Liza Koshy (A Family Affair), Nicole 
Byer (Nailed It!), Matt Cornett (High School Musical: The Musical: 
The Series), Fernando Carsa (Acapulco) and Amalia Yoo (Grand Army). 
Production is set to kick off in Syracuse, NY this month.` }
        },
    ],
    selected : "",
    section : sectionID,
}

const mkSlugTree = (arr) => {
    const nst = {};
    for ( let i = 0; i < arr.length; i ++ ) {
        nst[arr[i].slug] = arr[i];
    }
    return nst;
}

const PressPage = () => {

    const slugTree = mkSlugTree(scrollerObject.data);
    const navigate = useNavigate();

    const loc = useLocation();
    const initPath = getSelected(loc.pathname);

    const [selected, setSelected] = useState(initPath);

    //console.log("initial path", loc.pathname, getSelected(loc.pathname));

    scrollerObject.selected = getSelected(loc.pathname);

    const ue = useEffect(() => {
        const nselected = getSelected(loc.pathname);
        setSelected(nselected);
        if ( initPath.toLowerCase() === sectionID || initPath === "" ) {
            navigate(`/${sectionID}/${scrollerObject.data[0].slug}`);
        }
        scrollerObject.selected = nselected;
    }, [loc, initPath, navigate])

    return (
        <PageContainer>
            <FlexColumn key={"column_left"} widthClass={"w30"}>
                <PortfolioScroller
                    thumbScroller={scrollerObject} 
                    textArea={{ 
                        text : markdown, 
                        styleRules : { mod : sectionID } }} />
            </FlexColumn>
            <FlexColumn key={"vertical_rule"} widthClass={"vertical_rule"}>
                <VerticalRule />
            </FlexColumn>
            <FlexColumn key={"colum_right"} widthClass={"rightcol"}>
                <PortfolioCopy {...slugTree[selected]} />
            </FlexColumn>
        </PageContainer>
    )
}

export default PressPage;